const HTML_TAG = /<[^>]*>/g;
const HTML_SPACE = /&(nbsp|#160|#x[aA]0);/g;

export function hasMeaningfulDocumentContent(value: unknown): boolean {
    if (typeof value !== "string") return false;
    return value
        .replace(HTML_SPACE, " ")
        .replace(HTML_TAG, "")
        .trim().length > 0;
}

/** Prevent an editor hydration/reset event from erasing a populated document. */
export function wouldErasePopulatedDocument(nextContent: unknown, persistedContent: unknown): boolean {
    return !hasMeaningfulDocumentContent(nextContent) && hasMeaningfulDocumentContent(persistedContent);
}
